import { graphql } from "react-relay";
import { SuggestionActionTravelTime } from "./SuggestionActionTravelTime";

export const suggestionActionTravelTimeFragments = {
  org: graphql`
    fragment SuggestionActionTravelTime_org on Org {
      id
      workAddressForUser {
        __typename
        ... on Address {
          rawAddress
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
    }
  `,
};
